import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, MessageSquare, ExternalLink, Loader2 } from 'lucide-react';
import { productsAPI } from '../../services/api';
import toast from 'react-hot-toast';

const AdminReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadReviews = async () => {
    try {
      setLoading(true);
      const res = await productsAPI.getAdminReviews({ limit: 50 });
      setReviews(res.data.reviews || []);
    } catch (error) {
      toast.error('Değerlendirmeler yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReviews();
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-orange-500" />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-6xl space-y-6 p-4 sm:p-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Ürün değerlendirmeleri</h1>
        <p className="mt-1 text-sm text-slate-600">
          Müşterilerin doğrulanmış alıcı yorumları. Yeni yorum geldiğinde e-posta alırsınız.
        </p>
      </div>

      {reviews.length === 0 ? (
        <div className="rounded-xl border border-slate-200 bg-white p-10 text-center text-slate-500">
          Henüz değerlendirme yok.
        </div>
      ) : (
        <div className="space-y-4">
          {reviews.map((review) => (
            <article
              key={review.id}
              className="rounded-xl border border-slate-200 bg-white p-4 sm:p-5 shadow-sm"
            >
              <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h2 className="font-semibold text-slate-900 truncate">
                      {review.product?.name || `Ürün #${review.product_id}`}
                    </h2>
                    {review.product?.id && (
                      <Link
                        to={`/product/${review.product.id}#reviews`}
                        className="inline-flex items-center gap-1 text-xs text-orange-600 hover:underline"
                      >
                        Ürün sayfası
                        <ExternalLink className="h-3 w-3" />
                      </Link>
                    )}
                  </div>
                  <p className="mt-1 text-sm text-slate-600">
                    {review.user?.name || 'Müşteri'}
                    {review.user?.email ? ` · ${review.user.email}` : ''}
                  </p>
                  <div className="mt-2 flex items-center gap-1">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <Star
                        key={s}
                        className={`h-4 w-4 ${
                          s <= review.rating ? 'fill-orange-400 text-orange-400' : 'text-slate-200'
                        }`}
                      />
                    ))}
                    <span className="ml-2 text-sm text-slate-500">{review.rating}/5</span>
                    {review.is_verified_purchase && (
                      <span className="ml-2 rounded-full bg-emerald-50 px-2 py-0.5 text-xs text-emerald-700">
                        Doğrulanmış alıcı
                      </span>
                    )}
                  </div>
                  {review.comment ? (
                    <p className="mt-3 text-sm text-slate-700 whitespace-pre-wrap rounded-lg bg-slate-50 p-3 border border-slate-100">
                      {review.comment}
                    </p>
                  ) : (
                    <p className="mt-3 text-sm text-slate-400 italic flex items-center gap-1">
                      <MessageSquare className="h-4 w-4" />
                      Yorum metni yok
                    </p>
                  )}
                </div>
                <time className="text-xs text-slate-500 shrink-0">
                  {review.created_at
                    ? new Date(review.created_at).toLocaleString('tr-TR')
                    : ''}
                </time>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminReviews;
